import React, { useEffect, useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { Spinner } from "react-bootstrap";
import { checkAuth } from "../../Actions/Auth";
import { userStatus, usersData } from "../../App";
import {
  parseHashTokens,
  isTokenValid,
  storeTokens,
  setAxiosAuthHeader,
  clearAuthStorage,
  cleanHashFromURL,
  decodeJWT,
} from "../../utils/autoLogin.js";

const AutoLogin = () => {
  const navigate = useNavigate();
  const { setUserLoggedIn, setIsUserEnabled } = useContext(userStatus);
  const { setUserData } = useContext(usersData);
  const [error, setError] = useState("");

  useEffect(() => {
    handleAutoLogin();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleAutoLogin = async () => {
    const { accessToken, refreshToken } = parseHashTokens();

    // --- Guard: missing tokens ---
    if (!accessToken || !refreshToken) {
      redirectToLogin("Missing tokens in URL.");
      return;
    }

    // --- Guard: expired token ---
    if (!isTokenValid(accessToken)) {
      redirectToLogin("Token is invalid or has expired.");
      return;
    }

    // --- Persist tokens ---
    storeTokens(accessToken, refreshToken);
    setAxiosAuthHeader(accessToken);

    // --- Clean the hash so tokens are not visible in the address bar ---
    cleanHashFromURL();

    // --- Validate with backend ---
    try {
      // Attempt to extract mobile number from the JWT payload to satisfy
      // the checkAuth body; fall back to an empty object if not present.
      const decoded = decodeJWT(accessToken);
      const mobileNumber = decoded?.mobileNo || decoded?.sub || "";

      const res = await checkAuth({ mobileNumber });
      const user = res.data.data.user;

      localStorage.setItem("userData", JSON.stringify(user));
      localStorage.setItem("notificationData", JSON.stringify([]));
      localStorage.setItem(
        "sessionCount",
        String(+(localStorage.getItem("sessionCount") || 0) + 1),
      );

      // --- Update global auth context ---
      setUserData(user);
      setIsUserEnabled(user.enabled);
      setUserLoggedIn(true);

      // --- Navigate based on business type ---
      const HOME_TYPES = ["PHARMACY", "FOOD"];
      const goToHome = HOME_TYPES.includes(user.businessType?.[0]) || user.enabled;
      navigate(goToHome ? "/home" : "/wholesale/home", { replace: true });
    } catch (err) {
      clearAuthStorage();
      redirectToLogin("Authentication failed. Please log in again.");
    }
  };

  const redirectToLogin = (msg) => {
    setError(msg);
    clearAuthStorage();
    setTimeout(() => navigate("/login", { replace: true }), 2000);
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "100vh",
        gap: "1rem",
      }}>
      {error ? (
        <p style={{ color: "#e53e3e", fontWeight: 500 }}>{error}</p>
      ) : (
        <>
          <Spinner animation="border" variant="primary" />
          <p style={{ color: "#555" }}>Signing you in…</p>
        </>
      )}
    </div>
  );
};

export default AutoLogin;
